import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import { UserData } from './user-data';
import { CommonData } from '../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";

@Injectable()
export class KontrolleData {
  data: any;
  kontrollstatus : any;
  constructor(public http: Http, public common: CommonData, public userData: UserData) {
    this.data = [];

  }
  clear(){
    if(this.data!=null){
      this.data.length = 0;
    }
  }
  load() {
    if (this.data) {
      return Promise.resolve(this.data);
    }

    // don't have the data yet
    return new Promise(resolve => {
      if(this.userData.loggedin){

        this.http.get(this.common.baseurl+'grundstuecke/getall?token='+this.userData.jwt).subscribe(res => {
          // we've got back the raw data, now generate the core schedule data
          // and save the data for later reference
          //this.data = this.processData(res.json());
          this.data = res.json().data;
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer pp-data.ts');
          console.log(error);
      });

      }
    });
  }

  loadKontrollenStatus(){
    return new Promise(resolve => {
      if(this.userData.loggedin){
        //console.log(grundid);
        this.http.get(this.common.baseurl+'kontrollstatuse/view?token='+this.userData.jwt).subscribe(res => {
          //console.log(res.json().data);
          this.kontrollstatus = res.json().data;
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer pp-data.ts');
          console.log(error);
      });

      }
    });    
  }

  getStatusnameByStatus(statusid){
    let i=0;
    for(i=0; i<this.kontrollstatus.length; i++){
      //console.log(this.kontrollstatus[i]);
      if(this.kontrollstatus[i].ksid == statusid){
        return this.kontrollstatus[i].sname;                
      }
    }
    return statusid;       
  }
  getStatuscolorByStatus(statusid){
    let i=0;
    for(i=0; i<this.kontrollstatus.length; i++){
      //console.log(this.kontrollstatus[i]);
      if(this.kontrollstatus[i].ksid == statusid){
        //console.log(this.kontrollstatus[i].statusfarbe);
        return this.kontrollstatus[i].statusfarbe;                
      }
    }
    return statusid;       
  }
  

  getParkplaetze() {
    return this.load().then(data => {
      console.log("getParkplaetze"+ data);
      return data;
    });
  }

  getKontrolle(kontrolle_id) {
    return new Promise(resolve => {
      if(this.userData.loggedin){
        //console.log(grundid);
        this.http.get(this.common.baseurl+'kontrollen/getkontrolle?kontrolle_id='+kontrolle_id+'&token='+this.userData.jwt).subscribe(res => {
          // we've got back the raw data, now generate the core schedule data
          // and save the data for later reference
          //this.data = this.processData(res.json());
          this.data = res.json().data;
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer pp-data.ts');
          console.log(error);
      });

      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/kontrolle-data.ts